// extracted by mini-css-extract-plugin
export default {"spinner":"circular-progress-module__spinner___tLLQN","rotate":"circular-progress-module__rotate___JUrT6"};